// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import Transition from '../../shared/transition';

export default class EditorTransition extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    timeout: PropTypes.number,
    className: PropTypes.string,
  };

  render() {
    const { appear, ...transitionProps } = this.props;

    return (
      <Transition
        {...transitionProps}
        timeout={this.props.timeout}
        className={cx(this.props.className, 'editor')}
        exitedClassName="exited"
        exitingClassName="exiting"
        enteredClassName="entered"
        enteringClassName="entering"
      >
        {this.props.children}
      </Transition>
    );
  }
}
